import { Dropdown } from "./Dropdown";

export function IngredientInputComponent({
  ingredient,
  quantityUnits,
  onChange,
  onEnterPress,
}) {
  const canAdd = () =>
    ingredient.name?.trim() && ingredient.quantity?.toString().trim();

  const handleNumericChange = (field, value) => {
    if (/^\d*\.?\d*$/.test(value)) {
      onChange(field, value);
    }
  };

  return (
    <>
      {/* Item Name */}
      <input
        type="text"
        placeholder="Item name..."
        value={ingredient.name || ""}
        onChange={(e) => onChange("name", e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && canAdd()) {
            onEnterPress?.(ingredient);
          }
        }}
        className="w-full md:flex-1 px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
      />

      {/* Quantity + Unit Row */}
      <div className="flex gap-2">
        {/* Quantity */}
        <input
          type="text"
          placeholder="Qty..."
          value={ingredient.quantity || ""}
          onChange={(e) => handleNumericChange("quantity", e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && canAdd()) {
              onEnterPress?.(ingredient);
            }
          }}
          className="flex-1 px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
        />

        {/* Units Dropdown */}
        <div className="flex-1">
          <Dropdown
            options={quantityUnits}
            selectedOption={ingredient.unit}
            onSelect={(unit) => onChange("unit", unit)}
          />
        </div>
      </div>
    </>
  );
}
